import React, { useState } from 'react';
import { NavbarProps } from './Navbar';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import HorizontalCenter from '@components/common/alignment/HorizontalCenter';

const MobileNavbar = (props: NavbarProps) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleClick = async () => {
    setShowMenu(!showMenu);
  };

  return (
    <nav className='fixed w-full z-20 text-xl'>
      <div className='p-4 z-10 relative bg-white flex flex-row'>
        <img src={process.env.PUBLIC_URL + '/favicon.ico'} className='transform w-8 h-8 mx-4' />
        <div className='ml-auto mr-4' onClick={handleClick}>
          <MenuIcon />
        </div>
      </div>
      <motion.ul
        className='origin-top z-0 relative bg-cultured'
        initial={{
          rotateX: -90,
          display: 'none',
        }}
        animate={{
          rotateX: showMenu ? 0 : -90,
          display: 'block',
          transitionEnd: {
            display: !showMenu ? 'none' : 'block',
          },
        }}
        transition={{ type: 'spring', stiffness: 200, damping: showMenu ? 10 : 20 }}
      >
        {props.links.map((link, i) => {
          return (
            <li key={i} className='w-full py-3'>
              <NavLink
                to={link.to}
                className='text-coffee text-4xl pb-3 mx-4 font-extrabold text-center block'
                onClick={handleClick}
              >
                {link.text}
              </NavLink>
              <HorizontalCenter>
                <hr className='w-2/3 h-0'></hr>
              </HorizontalCenter>
            </li>
          );
        })}
      </motion.ul>
    </nav>
  );
};

const MenuIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='icon icon-tabler icon-tabler-menu-2 transform w-8 h-8 stroke-current text-coffee'
      width='44'
      height='44'
      viewBox='0 0 24 24'
      strokeWidth='1.5'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <line x1='4' y1='6' x2='20' y2='6' />
      <line x1='4' y1='12' x2='20' y2='12' />
      <line x1='4' y1='18' x2='20' y2='18' />
    </svg>
  );
};

export default MobileNavbar;
